var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.ProjectSelectors.Q_AND_A_SECTION_WRAPPER},_vm._l((_vm.content.body),function(item,key){return _c('DcwQAndASection',{key:("" + (item.type) + key),attrs:{"content":item,"img":_vm.content.avatar}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }